import * as React from 'react';

import Message, { MessageProps } from '../Message';
import { TMessageWrapper } from '../MessageWrapper';
import Rescheduler from '../Rescheduler';

export interface TMessageAppointmentsProps extends Omit<MessageProps, 'classes' | 'message'> {
  message: TMessageWrapper;
}

const MessageAppointments = (props: TMessageAppointmentsProps) => {
  const { message, ...rest } = props;

  return (
    <>
      <Message message={message} {...rest} />
      <Rescheduler />
    </>
  );
};

export default MessageAppointments;
